<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <img v-if="$store.getters.lang == 'zh'" src="@/assets/images/Serve07_2@2x.png" alt="">
        <img v-else src="@/assets/images/Serve07_2en@2x.png" alt="">
        <div class="btn-list">
          <div class="item">
            <img src="@/assets/images/Serve08@2x.png" alt="">
            <span @click="toTanWeiXin">{{$t('otherPage.p2')}}</span>
          </div>
          <!--<div class="item">-->
            <!--<img src="@/assets/images/Serve09@2x.png" alt="">-->
            <!--<span @click="toTanGuoWai">{{$t('otherPage.p3')}}</span>-->
          <!--</div>-->
          <div class="item">
            <img src="@/assets/images/Serve10@2x.png" alt="">
            <span @click="toTanGuoWai">{{$t('otherPage.p4')}}</span>
          </div>
        </div>
        <div class="ql-editor" style="margin-bottom: 140px;margin-top: 112px;padding: 0;" v-html="content"></div>
        <!--<div class="feature">-->
          <!--<div class="title">购票须知</div>-->
          <!--<p>-->
            <!--<span>1</span>中国内地观众仅可使用身份证，非中国内地观众请使用港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳台居民居住证、外国人永久居留身份证或护照订票、检票，同一证件每个参观日仅能预约一张门票。-->
          <!--</p>-->
          <!--<p>-->
            <!--<span>2</span>观众务必携带预约时使用的有效证件原件由午门(故宫南门)检票入院。-->
          <!--</p>-->
          <!--<p>-->
            <!--<span>3</span>门票 (大门票和钟表馆、珍宝馆及展览预约)，应于参观前7日20:00开始预约，限参观当日使用有效。门票一经检票，不予退票。-->
          <!--</p>-->
          <!--<p>-->
            <!--<span>4</span>未使用的门票(大门票和钟表馆、珍宝馆及展览预约)可于参观前一日24:00前通过原订票渠道退票，不计爽约;参观当日20:00前仍可退票但计1次爽约;参观当日20:00后不可退票退款且计1次爽约。年票观众已登记但未检票的大门票可于参观当日20:00前通过原订单渠道取消，不计爽约。-->
          <!--</p>-->
          <!--<p>-->
            <!--<span>5</span>部分展览须预约，以预约页面信息为准。预约政策可能会因开放管理要求临时调整，敬请谅解并配合现场工作人员管理。如需退订，请于参观前一日24:00前通过原订票渠道退订，不计爽约。逾期未退订，计1次爽约。-->
          <!--</p>-->
          <!--<p>-->
            <!--<span>6</span>每人每日最多计1次爽约，180日内累计爽约3次，从第3次爽约的次日起，60日内将无法预约故宫博物院门票及展览。-->
          <!--</p>-->
        <!--</div>-->
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
    <!--二维码预约-->
    <!--<el-dialog :title="title" :visible.sync="dialogVisible" width="1500px" append-to-body :before-close="cancel">-->
    <el-dialog append-to-body :visible.sync="dialogVisible_WeiXin" :lock-scroll="false" width="800px" @close="toHideDialog">
      <div class="tan_weixin">
        <img class="title" v-if="$store.getters.lang == 'en'"  src="@/assets/images/Serve12_2@2x.png" alt="">
        <img class="title" v-else  src="@/assets/images/Serve12@2x.png" alt="">
        <img class="code" src="@/assets/images/Serve13@2x.png" alt="">
      </div>
    </el-dialog>
    <!--国内观众预约-->
    <el-dialog append-to-body :visible.sync="dialogVisible_GuoWai" :lock-scroll="false" width="700px" @close="toHideDialog">
      <div  v-if="!dialogVisible_GuoWai_BookSuccess" class="tan_guowai">
        <img class="title" v-if="$store.getters.lang == 'en'" src="@/assets/images/Serve18_2@2x.png" alt="">
        <img class="title" v-else src="@/assets/images/Serve18@2x.png" alt="">
        <div class="form">
          <el-form ref="form" :model="form" :rules="$store.getters.lang == 'en'?rules2:rules" label-width="100px">
            <!--@keyup.enter.native="handleQuery"-->
            <!--clearable-->
            <el-form-item :label="$t('otherPage.p30')" prop="userName">
              <el-input style="width: 430px;" v-model="form.userName" :placeholder="$t('otherPage.p31')" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p32')" prop="cardType">
              <el-select style="width: 430px;" v-model="form.cardType" :placeholder="$t('otherPage.p33')">
                <el-option :label="$t('otherPage.p34')" :value="$t('otherPage.p34')"></el-option>
                <el-option :label="$t('otherPage.p35')" :value="$t('otherPage.p35')"></el-option>
                <el-option :label="$t('otherPage.p36')" :value="$t('otherPage.p36')"></el-option>
                <el-option :label="$t('otherPage.p37')" :value="$t('otherPage.p37')"></el-option>
                <el-option :label="$t('otherPage.p38')" :value="$t('otherPage.p38')"></el-option>
                <el-option :label="$t('otherPage.p39')" :value="$t('otherPage.p39')"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p40')" prop="cardNo">
              <el-input style="width: 430px;" v-model="form.cardNo" :placeholder="$t('otherPage.p41')" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p42')" prop="email">
              <el-input style="width: 430px;" v-model="form.email" :placeholder="$t('otherPage.p43')" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p44')" prop="smsCode">
              <el-input style="width: 310px;" v-model="form.smsCode" :placeholder="$t('otherPage.p45')" maxlength="10"></el-input>
              <div style="width: 100px;float: right;margin-right: 10px;">
                <el-button  type="primary" @click="toGetValidCode" style=" border-color: #DA1E2D; background: #DA1E2D; border-radius: 5px;" >{{$t('otherPage.p46')}}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('otherPage.p47')" prop="bookDate">
              <el-date-picker
                style="width: 430px;"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                v-model="form.bookDate"
                type="date"
                :placeholder="$t('otherPage.p48')">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button class="btn" type="primary" @click="toSubmit">{{$t('otherPage.p49')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="dialogVisible_GuoWai_BookSuccess"  class="tan_success">
        <img src="https://www.cwmuseum.cn/img/Serve20@2x.png" alt="">
        <img src="https://www.cwmuseum.cn/img/Serve21@2x.png" alt="">
        <div class="summary">{{$t('otherPage.p50')}}</div>
        <div class="btn" @click="toHideDialog">{{$t('otherPage.p49')}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getSingle,getTokenCode,getEmailValidCode,bookingByEmailValidCode} from "@/api";
  import {mixin} from '@/mixin/index.js';
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "A2",
    mixins : [mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data() {
      return {
        secretCode:"",/////安全码
        // 富文本内容
        content: ``,
        // 弹窗
        dialogVisible_GuoWai: false,
        dialogVisible_WeiXin: false,
        dialogVisible_GuoWai_BookSuccess: false, //////预订成功
        // 表单元素
        form: {
          userName: '',
          cardType: '',
          cardNo: '',
          email: '',
          smsCode: '',
          valideCode:"",
          tel:"",
          bookDate:null,
        },
        // 表单规则
        rules2: {
          userName: [
            {required: true, message: "The real name cannot be empty", trigger: "blur"}
          ],
          cardType: [
            {required: true, message: "The ID type cannot be empty", trigger: ["blur", "change"]}
          ],
          cardNo: [
            {required: true, message: "The ID number cannot be empty", trigger: "blur"}
          ],
          email: [
            { required: true, message: "The email address cannot be empty", trigger: "blur" },
            { type: "email",message: "Please enter the correct email address", trigger: ["blur", "change"]}
          ],
          smsCode: [
            {required: true, message: "The verification code cannot be empty", trigger: "blur"}
          ],
          bookDate: [
            {required: true, message: "Time cannot be empty", trigger: "blur"}
          ],
        },
        rules: {
          userName: [
            {required: true, message: "真实姓名不能为空", trigger: "blur"}
          ],
          cardType: [
            {required: true, message: "证件类型不能为空",trigger: ["blur", "change"]}
          ],
          cardNo: [
            {required: true, message: "证件号码不能为空", trigger: "blur"}
          ],
          email: [
            { required: true, message: "邮箱地址不能为空", trigger: "blur" },
            { type: "email",message: "请输入正确的邮箱地址", trigger: ["blur", "change"]}
          ],
          smsCode: [
            {required: true, message: "验证码不能为空", trigger: "blur"}
          ],
          bookDate: [
            {required: true, message: "时间不能为空", trigger: "blur"}
          ],
        },
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.getData()
      }
    },
    created() {
      this.getData();
      this.getSecretCode();
    },
    methods: {
      async getData(val) {
        let params = {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "门票预约",
          articleKey:'cms'
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await getSingle(params)
        rows[0].articleContent = this.updateImageUrl(rows[0].articleContent)
        this.content = rows[0].articleContent
      },
      async getSecretCode(){
        let _res = await getTokenCode( );
        this.secretCode=_res.data.msg;
        this.form.valideCode=_res.data.msg;
      },

      // 海外观众预约（邮箱、短信）
      toTanGuoWai() {
        this.dialogVisible_GuoWai = true
      },
      // 二维码预约
      toTanWeiXin() {
        this.dialogVisible_WeiXin = true
      },
      // 关闭弹窗
      toHideDialog() {
        this.form = {
          userName: '',
          cardType: '',
          cardNo: '',
          email: '',
          smsCode: '',
          valideCode:"",
          tel:"",
          bookDate:null,
        }
        if(this.dialogVisible_GuoWai_BookSuccess == false){
          this.$refs['form'].clearValidate()
        }
        this.dialogVisible_WeiXin = false
        this.dialogVisible_GuoWai = false
        this.dialogVisible_GuoWai_BookSuccess=false;
      },
      // 提交表单
      toSubmit() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            bookingByEmailValidCode(this.form).then(response => {
                // console.log("bookingByEmailValidCode:",response)
                if (response.data.msg=="ok"){
                  if(this.$store.getters.lang == 'en'){
                    this.$message({
                      message: 'Booking is successful! Booking information has been sent to you in the mail',
                      type: 'success'
                    });
                  }else{
                    this.$message({
                      message: '预订成功！预订信息已发送到您的邮件中',
                      type: 'success'
                    });
                  }

                  this.dialogVisible_GuoWai_BookSuccess=true;
                }else {
                  this.$message.error(response.data.msg);
                }

            });
          }
        });
      },
      toGetValidCode(){

        this.$refs["form"].validateField('email', valid => {
            if(valid=="") {
              if (this.form.email==null || this.form.email==""){
                if(this.$store.getters.lang == 'en'){
                  this.$message.error('The email address cannot be empty');
                }else{
                  this.$message.error('邮箱地址不能为空');
                }
                return false;
              }
              getEmailValidCode(this.form).then(response => {
                  // console.log("get:",response)
                  if (response.data.msg=="ok"){
                    if(this.$store.getters.lang == 'en'){
                      this.$message({
                        message: 'The verification code has been sent to your email',
                        type: 'success'
                      });
                    }else{
                      this.$message({
                        message: '验证码已经发到了您的电子邮箱中',
                        type: 'success'
                      });
                    }
                  }else {
                    this.$message.error(response.data.msg);
                  }

              });

            }
        })


      }



    }
  }
</script>

<style scoped>

</style>
<style scoped lang="less">
  body {
    background: #f6f6f6;
  }

  .container {
    .wrap {
      width: 1380px;
      margin: 0 auto;
      overflow: hidden;

      > img {
        display: block;
        margin: 0 auto 80px;
      }

      .btn-list {
        display: flex;
        justify-content: space-around;
        padding: 0 140px;
        .item {
          display: flex;
          flex-direction: column;

          span {
            font-family: Source Han Sans CN;
            font-size: 22px;
            color: #FFFFFF;
            width: 140px;
            height: 46px;
            background: #DA1E2D;
            border-radius: 8px;
            line-height: 46px;
            text-align: center;
            margin: 40px auto 0;
            cursor: pointer;
          }
        }
      }

      .feature {
        width: 100%;
        height: 709px;
        background: url("https://www.cwmuseum.cn/img/Serve11@2x.png") no-repeat;
        margin-bottom: 140px;
        margin-top: 112px;
        overflow: hidden;
        padding: 0 90px 0 80px;

        .title {
          font-weight: 400;
          font-size: 30px;
          color: #333333;
          text-align: center;
          display: block;
          margin: 70px auto 36px;
        }

        p {
          display: flex;

          font-family: Source Han Sans CN;
          font-size: 20px;
          color: #333333;
          line-height: 48px;
          text-align: justify;

          span {
            flex: 0 0 26px;
            height: 26px;
            background: #41454A;
            border-radius: 50%;
            margin-right: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            top: 13px;
            color: #fff;
          }
        }
      }
    }
  }

  /* 弹窗css */
  /deep/ .el-dialog {
    margin-top: 10vh !important;
  }

  .tan_weixin {
    padding-bottom: 80px;

    .title {
      display: block;
      margin: 0 auto 60px;
    }

    .code {
      display: block;
      margin: 0 auto;
      width: 400px;
    }
  }

  .tan_guowai {
    padding-bottom: 20px;

    .title {
      display: block;
      margin: 0 auto 60px;
    }

    .form {
      display: flex;
      padding-left: 50px;

      /deep/ .el-form-item__label {
        font-family: SourceHanSans;
        font-size: 16px;
        color: #DA1E2D;
        padding: 0 20px 0 0;
      }

      /deep/ .el-input__inner {
        font-family: SourceHanSans;
        font-weight: 400;
        font-size: 16px;
        color: #A5ABB7;
        height: 48px;
        background: #F0F2F6;
        border-radius: 5px;
        border: none;
      }

      .el-form-item {
        margin-bottom: 24px;
      }

      .btn {
        border-color: #DA1E2D;
        width: 430px;
        height: 48px;
        background: #DA1E2D;
        border-radius: 5px;
        margin-top: 24px;
      }
    }
  }

  .tan_success {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;

    img:nth-child(1) {
      width: 259px;
    }

    img:nth-child(2) {
      width: 112px;
    }

    .summary {
      width: 528px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #555555;
      line-height: 32px;
      margin-top: 20px;
      text-align: justify;
    }

    .btn {
      width: 168px;
      height: 48px;
      line-height: 48px;
      background: #DA1E2D;
      border-radius: 5px;
      margin: 70px auto 0;
      display: block;
      font-family: SourceHanSans;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Serve/A2/A2.vue